// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../../common/image.res.js");
var Filter$ReactHooksTemplate = require("./filter.res.js");
var FilterPills$ReactHooksTemplate = require("./filterPills.res.js");

function FilterPillsElement(props) {
  var handleResetFilter = props.handleResetFilter;
  var t = props.t;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: FilterPills$ReactHooksTemplate.toString(t),
                      className: "text-xs"
                    }),
                JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsx("img", {
                            className: "w-2 ml-2",
                            src: Image$ReactHooksTemplate.closeIcon
                          }),
                      id: "filter_reset",
                      style: {
                        outline: "None"
                      },
                      onClick: (function (param) {
                          Curry._1(handleResetFilter, Filter$ReactHooksTemplate.resetSelected(FilterPills$ReactHooksTemplate.filter(t)));
                        })
                    })
              ],
              className: "flex items-center bg-ghostwhite text-center px-3 rounded-2xl border border-gray-400 " + props.height
            });
}

var make = FilterPillsElement;

exports.make = make;
/* react/jsx-runtime Not a pure module */
